<template>
  <div class="entity-analysis-page">
    <h1>Real Time Entity Analysis</h1>
    <p>The text box below will analyse text and identify entities based on the <a href="https://spacy.io/api/annotation#named-entities" target="_blank">OntoNotes 5 corpus entity types</a>.</p>
    <p>When you hit the space bar the text will be analysed and found entities will be highlihgted.</p>
    <EntityAnalysis v-bind:showResults="true" />
  </div>
</template>

<script>
import EntityAnalysis from '../components/EntityAnalysis'
export default {
  name: 'EntityAnalysisPage',
  components: {
    EntityAnalysis
  }
}
</script>
